import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ContingentBundle } from '../../store/contingent/model/contingent-bundle.model';
import { environment } from '../../../environments/environment';
import { ContingentQuery } from '../../store/contingent/model/contingent-query.model';
import { UserContingent } from '../../store/user-management/model/user-contingent.model';

@Injectable({
    providedIn: 'root'
})
export class ContingentService {
    constructor(private http: HttpClient) {}

    loadContingentBundles(): Observable<ContingentBundle[]> {
        return this.http.get<ContingentBundle[]>(`${environment.host}/contingent/bundles`);
    }

    searchContingentBundles(contingentBundles: ContingentBundle[], searchString: string): ContingentBundle[] {
        return contingentBundles.filter((contingentBundle) => contingentBundle.name.toLowerCase().includes(searchString.toLowerCase()));
    }

    getUserContingent(query?: ContingentQuery): Observable<UserContingent[]> {
        if (query?.date) {
            return this.http.get<UserContingent[]>(
                `${environment.host}/contingent/usageOverviews/course/${query.courseId}/user/${query.userId}?forDate=${encodeURIComponent(query.date)}`
            );
        } else {
            return of([]);
        }
    }
}
